<div class="container mt-4 mb-5">
  <app-register-stepper [progressData]="getProgressData()" [user]="user"></app-register-stepper>

  <ngb-alert
    *ngIf="alert"
    [type]="alert.type"
    (closed)="closeAlert()"
    class="sticky-top"
    style="top: 10px"
    >{{ alert.message }}</ngb-alert
  >

  <div class="row mb-3">
    <div class="col-12">
      <h1 *ngIf="isConfirm" class="text-center">Your pet's details</h1>
      <h1 *ngIf="!isConfirm">Edit {{ currentPetName }}'s Bio</h1>
    </div>
  </div>

  <div *ngIf="isConfirm" class="row mb-5">
    <div class="col-12 col-lg-8 offset-lg-2">
      <h5 class="text-center">
        Please check your pet’s details below. Some of the details are already
        filled in at the point of implantation, so please give us a call if you
        need to update these.
      </h5>
      <h6 class="text-center">
        Chip number: {{ pet.chipNumber }}
      </h6>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <form #editPetForm="ngForm" (ngSubmit)="save()">
        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petName"> Pet name </label>
              <input
                #petName="ngModel"
                class="form-control"
                [class.is-invalid]="petName.touched && petName.invalid"
                id="petName"
                name="petName"
                [(ngModel)]="pet.name"
                placeholder="Your pet's name"
                type="text"
                required
              />
              <div
                *ngIf="petName.invalid && petName.errors.required"
                class="invalid-feedback"
              >
                {{ errorStrings.required }}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petDob"> Date of birth </label>
              <div class="input-group">
                <input
                  #petDob="ngbDatepicker"
                  #petDobModel="ngModel"
                  class="form-control"
                  [class.is-invalid]="
                    petDobModel.touched && petDobModel.invalid
                  "
                  name="petDob"
                  [(ngModel)]="petDobValue"
                  placeholder="dd/mm/yyyy"
                  ngbDatepicker
                  [maxDate]="today"
                  [minDate]="minDate"
                  [disabled]="pet.isTokPaymentRequired"
                  required
                />
                  <button
                    class="btn btn-outline-secondary calendar"
                    (click)="petDob.toggle()"
                    type="button"
                  >
                    <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                  </button>
                <div
                  *ngIf="petDobModel.invalid && petDobModel.errors.required"
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
                <div
                  *ngIf="
                    petDobModel.invalid &&
                    petDobModel.errors.ngbDate &&
                    petDobModel.errors.ngbDate.invalid
                  "
                  class="invalid-feedback"
                >
                  {{ errorStrings.invalidDateForm }}
                </div>
                <div
                  *ngIf="
                    petDobModel.invalid &&
                    petDobModel.errors.ngbDate &&
                    petDobModel.errors.ngbDate.maxDate
                  "
                  class="invalid-feedback"
                >
                  Please enter a date not later than today.
                </div>
                <div
                  *ngIf="
                    petDobModel.invalid &&
                    petDobModel.errors.ngbDate &&
                    petDobModel.errors.ngbDate.minDate
                  "
                  class="invalid-feedback"
                >
                  Please enter a date after
                  {{
                    petDobModel.errors.ngbDate.minDate.minDate.day +
                      "/" +
                      petDobModel.errors.ngbDate.minDate.minDate.month +
                      "/" +
                      petDobModel.errors.ngbDate.minDate.minDate.year
                  }}.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="species"> Species </label>
              <select
                #petSpecies="ngModel"
                class="form-control form-select"
                [class.is-invalid]="petSpecies.touched && petSpecies.invalid"
                id="petSpecies"
                name="petSpecies"
                [(ngModel)]="selectedSpecies"
                (ngModelChange)="updateBreedsList()"
                [disabled]="loadingSpecies || pet.isTokPaymentRequired"
                required
              >
                <option [ngValue]="null" disabled>
                  {{ loadingSpecies ? "Loading..." : "Please select..." }}
                </option>
                <option *ngFor="let species of speciesList" [ngValue]="species">
                  {{ species.description }}
                </option>
              </select>
              <div
                *ngIf="petSpecies.invalid && petSpecies.errors.required"
                class="invalid-feedback"
              >
                {{ errorStrings.required }}
              </div>
            </div>
          </div>

          <div *ngIf="!isNewPet" class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petImplantDate"> Implant date </label>
              <input
                class="form-control"
                id="petImplantDate"
                name="petImplantDate"
                [ngModel]="pet.implantDate | date : 'dd/MM/y'"
                type="text"
                readonly
              />
            </div>
          </div>

          <div *ngIf="isNewPet" class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="implantDate"> Implant date </label>
              <div class="input-group">
                <input
                  #implantDate="ngbDatepicker"
                  #implantDateModel="ngModel"
                  class="form-control"
                  [class.is-invalid]="
                    implantDateModel.touched && implantDateModel.invalid
                  "
                  name="implantDate"
                  [(ngModel)]="petImplantDateValue"
                  placeholder="dd/mm/yyyy"
                  ngbDatepicker
                  [maxDate]="today"
                  [minDate]="minDate"
                  [disabled]="pet.isTokPaymentRequired"
                  required
                />
                  <button
                    class="btn btn-outline-secondary calendar"
                    (click)="implantDate.toggle()"
                    type="button"
                  >
                    <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                  </button>
                <div
                  *ngIf="
                    implantDateModel.invalid && implantDateModel.errors.required
                  "
                  class="invalid-feedback"
                >
                  {{ errorStrings.required }}
                </div>
                <div
                  *ngIf="
                    implantDateModel.invalid &&
                    implantDateModel.errors.ngbDate &&
                    implantDateModel.errors.ngbDate.invalid
                  "
                  class="invalid-feedback"
                >
                  {{ errorStrings.invalidDateForm }}
                </div>
                <div
                  *ngIf="
                    implantDateModel.invalid &&
                    implantDateModel.errors.ngbDate &&
                    implantDateModel.errors.ngbDate.maxDate
                  "
                  class="invalid-feedback"
                >
                  Please enter a date not later than today.
                </div>
                <div
                  *ngIf="
                    implantDateModel.invalid &&
                    implantDateModel.errors.ngbDate &&
                    implantDateModel.errors.ngbDate.minDate
                  "
                  class="invalid-feedback"
                >
                  Please enter a date after
                  {{
                    implantDateModel.errors.ngbDate.minDate.minDate.day +
                      "/" +
                      implantDateModel.errors.ngbDate.minDate.minDate.month +
                      "/" +
                      implantDateModel.errors.ngbDate.minDate.minDate.year
                  }}.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petBreed"> Breed </label>
              <input
                #petBreed="ngModel"
                #petBreedTypeahead="ngbTypeahead"
                class="form-control"
                [class.is-invalid]="petBreed.touched && petBreed.invalid"
                id="petBreed"
                name="petBreed"
                [(ngModel)]="pet.breed"
                [ngbTypeahead]="searchBreed"
                (ngModelChange)="updateSelectedBreed()"
                [disabled]="!pet.species || loadingSpecies || loadingBreeds || pet.isTokPaymentRequired"
                [placeholder]="
                  pet.species
                    ? 'Please enter the breed...'
                    : 'Select species first...'
                "
                [editable]="false"
                placement="bottom-left"
                (focus)="focus$.next($any($event).target.value)"
                (click)="click$.next($any($event).target.value)"
                required
                type="text"
              />
              <div *ngIf="pet.species" class="text-muted mt-1">
                <small
                  >Start typing to view suggestions and select from the
                  list.</small
                ><br />
                <small
                  >If you can't find it,
                  <a href="javascript:void(0)" (click)="openBreedSelector()"
                    >click here</a
                  >
                  to see the full list for the species selected.</small
                >
              </div>
              <div
                *ngIf="petBreed.invalid && petBreed.errors.required"
                class="invalid-feedback"
              >
                Please select a breed from the list.
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petSex"> Sex </label>
              <select
                #petSex="ngModel"
                class="form-control form-select"
                [class.is-invalid]="petSex.touched && petSex.invalid"
                id="petSex"
                name="petSex"
                [(ngModel)]="pet.gender"
                [disabled]="pet.isTokPaymentRequired"
                required
              >
                <option [ngValue]="petGender.Male">Male</option>
                <option [ngValue]="petGender.Female">Female</option>
              </select>
              <div
                *ngIf="petSex.invalid && petSex.errors.required"
                class="invalid-feedback"
              >
                {{ errorStrings.required }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petNeuteredSpayed"> Neutered/spayed </label>
              <select
                #petNeuteredSpayed="ngModel"
                class="form-control form-select"
                [class.is-invalid]="
                  petNeuteredSpayed.touched && petNeuteredSpayed.invalid
                "
                id="petNeuteredSpayed"
                name="petNeuteredSpayed"
                [(ngModel)]="pet.neutered"
                [disabled]="pet.isTokPaymentRequired"
                required
              >
                <option [ngValue]="null" disabled>Please select...</option>
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div
                *ngIf="
                  petNeuteredSpayed.invalid && petNeuteredSpayed.errors.required
                "
                class="invalid-feedback"
              >
                {{ errorStrings.required }}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="instagram"> Pet’s Instagram handle </label>
              <input
                #instagram="ngModel"
                class="form-control"
                [class.is-invalid]="instagram.touched && instagram.invalid"
                id="instagram"
                name="instagram"
                [(ngModel)]="pet.instagram"
                placeholder="Instagram"
                [disabled]="pet.isTokPaymentRequired"
                type="text"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petColoursMarkings"> Colours/markings </label>
              <textarea
                class="form-control"
                id="petColoursMarkings"
                name="petColoursMarkings"
                [(ngModel)]="pet.coloursMarkings"
                [disabled]="pet.isTokPaymentRequired"
                rows="4"
              >
              </textarea>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="petExistingConditions"> Existing conditions </label>
              <textarea
                class="form-control"
                id="petExistingConditions"
                name="petExistingConditions"
                [(ngModel)]="pet.existingConditions"
                [disabled]="pet.isTokPaymentRequired"
                rows="4"
              >
              </textarea>
            </div>
          </div>
        </div>

        <div *ngIf="showIndoorOutdoorSection">
          <div class="form-group" class="text-center">
            <label for="typeOfCat"> What type of cat are they? </label>
            <div class="d-flex flex-column justify-content-center align-items-center">
              <div class="form-check-wrapper">
                <div class="form-check">
                  <input
                    #typeOfCat="ngModel"
                    type="checkbox"
                    id="typeOfCatIndoor"
                    name="typeOfCatIndoor"
                    [(ngModel)]="checkedIsIndoor"
                    [checked]="checkedIsIndoor"
                    (change)="toggleOutdoor(false)"
                    class="form-check-input"
                    [required]="checkedIsIndoor || !checkedIsOutdoor"
                  />
                  <label class="form-check-label" for="typeOfCatIndoor">
                    Strictly indoor – my cat will not have unsupervised access to the outside
                  </label>
                </div>
                <div class="form-check mt-1">
                  <input
                    type="checkbox"
                    #typeOfCatOutdoor="ngModel"
                    id="typeOfCatOutdoor"
                    name="typeOfCatOutdoor"
                    [(ngModel)]="checkedIsOutdoor"
                    [checked]="checkedIsOutdoor"
                    (change)="toggleOutdoor(true)"
                    class="form-check-input"
                    [required]="!checkedIsIndoor || checkedIsOutdoor"
                  />
                  <label class="form-check-label" for="typeOfCatOutdoor">
                    Outdoor – my cat will have some or all access to the outside
                  </label>
                </div>
              </div>
            </div>            
          </div>
        </div>

        <hr class="mt-4 mb-5" />

        <div class="row mb-3">
          <div class="col-md-4 offset-md-4 mb-3">
            <button
              *ngIf="isConfirm && canAddAnotherPet && userRegistrationIsInProgress"
              class="btn btn-secondary text-white btn-lg w-100 mb-2"
              [disabled]="!editPetForm.valid || loading"
              type="submit"
              (click)="onSaveAndAddAnotherButtonClick()"
            >
              <fa-icon
                *ngIf="loading"
                [icon]="['fas', 'spinner']"
                [animation]="'spin'"
                class="me-3"
              ></fa-icon>
              <span>
                {{ loading ? "Saving" : "Add another pet" }}
              </span>
            </button>
            <button
              class="btn btn-success text-white btn-lg w-100"
              [disabled]="!editPetForm.valid || loading"
              type="submit"
            >
              <fa-icon
                *ngIf="loading"
                [icon]="['fas', 'spinner']"
                [animation]="'spin'"
                class="me-3"
              ></fa-icon>
              <span *ngIf="isConfirm">
                {{ loading ? "Saving" : "Next" }}
              </span>
              <span *ngIf="!isConfirm">
                {{ loading ? "Saving" : "Save" }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="!isConfirm" class="row mb-3">
    <div class="col-12 d-flex justify-content-start mb-3">
      <a *ngIf="!redirectParams" [routerLink]="['/my-pet', pet.id]">
        <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my pet
        details
      </a>
      <a
        *ngIf="redirectParams"
        [routerLink]="redirectParams.l"
        [queryParams]="redirectParams.q"
        [fragment]="redirectParams.f"
      >
        <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back
      </a>
    </div>
  </div>
</div>
